if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


// Codex availability fallback for stale Shopify full-page renders
(() => {
  async function refreshProductAvailabilityFromJson() {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;

    const form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) return;

    let product;
    try {
      const response = await fetch(`/products/${match[1]}.js?_availability=${Date.now()}`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) return;
      product = await response.json();
    } catch (error) {
      return;
    }

    const currentVariant = product.variants?.find((variant) => String(variant.id) === String(variantInput.value));
    const availableVariant = currentVariant?.available ? currentVariant : product.variants?.find((variant) => variant.available);
    if (!availableVariant) return;

    variantInput.value = availableVariant.id;
    variantInput.disabled = false;
    variantInput.removeAttribute('disabled');

    const productForm = form.closest('product-form') || form;
    const submitButton = productForm.querySelector('[name="add"]');
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.removeAttribute('disabled');
      submitButton.removeAttribute('aria-disabled');
      submitButton.classList.remove('loading');
      const buttonText = submitButton.querySelector('span');
      if (buttonText) buttonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
    }

    document.querySelectorAll('.price--sold-out').forEach((element) => element.classList.remove('price--sold-out'));
    document.querySelectorAll('.price__badge-sold-out').forEach((element) => {
      element.hidden = true;
      element.style.display = 'none';
    });
    document.querySelectorAll('shopify-accelerated-checkout[disabled]').forEach((element) => element.removeAttribute('disabled'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshProductAvailabilityFromJson);
  } else {
    refreshProductAvailabilityFromJson();
  }
  document.addEventListener('shopify:section:load', refreshProductAvailabilityFromJson);
})();


// Codex Estonian dynamic checkout translation
(() => {
  const translatedLabel = 'Osta kohe';

  function isEstonianStorefront() {
    return document.documentElement.lang?.toLowerCase().startsWith('et')
      || window.Shopify?.locale === 'et'
      || window.location.pathname.startsWith('/et/');
  }

  function translateDynamicCheckoutButton() {
    if (!isEstonianStorefront()) return;

    document.querySelectorAll('.shopify-payment-button__button--unbranded').forEach((button) => {
      const currentText = button.textContent.trim();
      if (/^Buy it now$/i.test(currentText)) {
        button.textContent = translatedLabel;
      }
      if (button.getAttribute('aria-label') === 'Buy it now') {
        button.setAttribute('aria-label', translatedLabel);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateDynamicCheckoutButton);
  } else {
    translateDynamicCheckoutButton();
  }

  window.addEventListener('load', translateDynamicCheckoutButton);
  document.addEventListener('shopify:section:load', translateDynamicCheckoutButton);
  setTimeout(translateDynamicCheckoutButton, 300);
  setTimeout(translateDynamicCheckoutButton, 1200);

  const observer = new MutationObserver(translateDynamicCheckoutButton);
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
